import _ from 'lodash';

import Utils from '@/assets/js/Utils';

import ObjectData from '@/assets/data/object';

const IMAGES = [
  'button_pause.png',
  'number_l_spritesheet.png',
  'number_m_spritesheet.png',
  'number_s_spritesheet_yellow.png',
  'number_s_spritesheet.png'
];

export default class PreloadImages {
  static load() {
    const images = PreloadImages.get();
    // const length = images.length;
    // let counter = 0;
    return Promise.all(
      _.map(images, src => {
        return Utils.loadImage(src).then(() => {
          // counter++;
          // this.loadedRatio = Math.floor((counter / length) * 99);
          // console.log(Math.floor((counter / length) * 99));
        });
      })
    );
  }

  static get() {
    const result = [];
    const loadImages = _.concat(IMAGES, PreloadImages.getObjectDataImages());
    _.forEach(loadImages, filename => {
      const image = require(`@/assets/images/game/${filename}`);
      result.push(image);
    });
    return result;
  }

  static getObjectDataImages() {
    const result = [];
    _.forEach(ObjectData, (info, index) => {
      const image = info.image;
      if (Array.isArray(image)) {
        for (let i = 0; i < image.length; i++) {
          result.push(`object/${image[i]}`);
        }
      } else {
        result.push(`object/${image}`);
      }
    });
    return result;
  }
}
